import { useEffect, useState } from 'react';
import Chart from "react-apexcharts";
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import DateRange from '../../../components/DateRange/DateRange';
import { dateIntoYYYY_MM_DD } from '../../../utils/dateTimeConverter';

const UserRegistrationChart = () => {

    const [selected, setSelected] = useState(1);

    const [date, setDate] = useState({ startDate: '', endDate: '' });

    const [isFetched, setIsFetched] = useState(false);

    const [series, setSeries] = useState([{
        name: 'Registered Users',
        data: []
    }, {
        name: 'Active Users',
        data: []
    }]);

    const [options, setOptions] = useState({
        chart: {
            type: 'area',
            toolbar: {
                show: false
            },
            zoom: {
                enable: false,
                allowMouseWheelZoom: false,
            },
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'smooth'
        }, fill: {
            type: "gradient",
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 1,
                opacityTo: 0,
                gradientToColors: ["white"],
                stops: [0, 100]
            }
        },
        xaxis: {
            type: 'datetime',
            categories: [],
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
            labels: {
                style: {
                    colors: 'var(--secondary-text)'
                }
            }
        },
        yaxis: {
            labels: {
                style: {
                    colors: 'var(--secondary-text)'
                }
            }
        },
        tooltip: {
            x: {
                format: 'dd/MM/yy'
            }, y: {
                formatter: undefined,
                title: {
                    formatter: (seriesName) => seriesName,
                },
            },
        },
        grid: {
            strokeDashArray: 6,
            column: {
                colors: undefined,
                opacity: 0.1
            },
        }
    });

    function onDateChange(p) {
        let newDate = { startDate: p.startDate._d, endDate: p.endDate._d }
        setDate(newDate)
    }

    async function getGraphData() {
        let tempRegisteredUser = [];
        let tempActiveUser = [];
        let tempArrX = [];
        let postData = {
            filter: selected
        }
        if (selected == 3) {
            postData["startDate"] = dateIntoYYYY_MM_DD(date.startDate);
            postData["endDate"] = dateIntoYYYY_MM_DD(date.endDate);
        }
        let resp = await postApi(postData, urlApi.userRegistrationGraph);

        if (resp.responseCode === 200) {
            setIsFetched(true);
            let count = 1;
            for (const item of resp.data) {
                if (selected == 1) {
                    tempArrX.push((count > 11 ? (count == 24 ? (count - 12) + "AM" : (count == 12 ? count : (count - 12)) + "PM") : (count + "AM")));
                    tempRegisteredUser.push(item?.hourlyRegisterUsers ?? 0);
                    tempActiveUser.push(item?.hourlyActiveUsers ?? 0);
                } else {
                    tempRegisteredUser.push(item?.registeredUsers ?? 0);
                    tempActiveUser.push(item?.activeUsers ?? 0);
                    tempArrX.push(item?.date);
                }
                count++;
            }

            let localSeries = [...series];
            localSeries[0].data = tempRegisteredUser;
            localSeries[1].data = tempActiveUser;
            setSeries(localSeries);

            setOptions({ ...options, xaxis: { ...options.xaxis, categories: tempArrX, type: selected == 1 ? 'time' : 'datetime' } });
        }
    }

    useEffect(() => {
        if (selected == 3 && !date?.startDate) {
            return
        }
        getGraphData();
    }, [selected, date]);

    function handleOnChange(value) {
        setSelected(parseInt(value));
        if (value !== 3) {
            setDate({ startDate: '', endDate: '' })
        }
    }

    return (
        <div className='bg-gray-50 p-1.5 rounded-xl h-full shadow-md'>
            <div className="flex justify-between items-center p-1 gap-2">
                <div>
                    <p className='mb-0 text-md font-bold text-[var(--grey)]'>Active & Registered Users</p>
                </div>
                <div className='flex ms-auto gap-2'>
                    <select name="" id="" className='form-control form-control-sm' onChange={(e) => { handleOnChange(e?.target?.value) }}>
                        <option value="1">Today</option>
                        <option value="2">Last 7 Days</option>
                        <option value="3">Custom</option>
                    </select>
                </div>
                {selected == 3 && <DateRange onApplyClick={(date) => onDateChange(date)} date={date} />}
            </div>
            {isFetched && <Chart options={options} series={series} height={'250px'} type="area" />}
        </div>
    )
}

export default UserRegistrationChart